import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import css from './OrdersOrdersMenuMultiselect.module.css';
import {getOptionForMultiselectOrdersMenu} from "../../../helpers";
import {ordersActions} from "../../../store/slices/orders-slices";
import {paginationActions} from "../../../store/slices/pagination-slices";


const OrdersOrdersMenuMultiselect = () => {
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedNames, setSelectedNames] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {filterParams} = useSelector(store => store.orders);

    const arrayItems = getOptionForMultiselectOrdersMenu(t);

    const updateFiltersAndFetch = (updatedNames) => {
        // Reset pagination to page 1 when status filters change
        dispatch(paginationActions.changePage(1));
        
        // Update filter params
        dispatch(ordersActions.setFilterParams({status: updatedNames}));
        
        // Fetch orders with new filters
        dispatch(ordersActions.getAllOrders({
            page: 1,
            ...filterParams,
            status: updatedNames
        }));
    };

    const handleMealSelect = (event) => {
        const options = Array.from(event.target.selectedOptions);

        const newSelected = options.map((option) => {
            const matched = arrayItems.find((obj) => obj.id === option.value);
            return {
                id: option.value,
                name: matched.name,
            };
        });

        setSelectedStatus((prev) => {
            const existingIds = prev.map((obj) => obj.id);
            const uniqueNew = newSelected.filter((obj) => !existingIds.includes(obj.id));
            return [...prev, ...uniqueNew];
        });

        const newNames = newSelected.map((item) => item.name.en);
        const updatedNames = Array.from(new Set([...selectedNames, ...newNames]));
        setSelectedNames(updatedNames);

        // Update filters and fetch data
        updateFiltersAndFetch(updatedNames);
    };

    const removeMeal = (mealId) => {
        const updatedStatus = selectedStatus.filter((meal) => meal.id !== mealId);
        const removedName = selectedStatus.find((meal) => meal.id === mealId)?.name.en;
        const updatedNames = selectedNames.filter((name) => name !== removedName);

        setSelectedStatus(updatedStatus);
        setSelectedNames(updatedNames);

        // Update filters and fetch data
        updateFiltersAndFetch(updatedNames);
    };

    return (
        <div className={css.row}>
            <div className={css.inputGroup}>
                <div className={css.customSelect}>
                    <div
                        className={css.selectedOptions}
                        onClick={() => setDropdownOpen((prev) => !prev)}
                    >
                        {selectedStatus.length > 0
                            ? selectedStatus.map((obj) => (
                                <span key={obj.id} className={css.optionTag}>
                                    {obj.name.en}
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            removeMeal(obj.id);
                                        }}
                                        className={css.removeButton}
                                    >
                                        &times;
                                    </button>
                                </span>
                            ))
                            : <span className={css.placeholder}>Status</span>}
                    </div>
                    {dropdownOpen && (
                        <select
                            id="availableMeals"
                            multiple
                            onChange={handleMealSelect}
                            className={css.select}
                        >
                            {arrayItems.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name.en}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            </div>
        </div>
    );
};

export {OrdersOrdersMenuMultiselect};

